"use client";

import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Cta() {
  const [mounted, setMounted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  const goRegister = () => {
    navigate("/register");
  };
  return (
    <section className="py-20 relative">
      {/* Background gradient effects */}
      <div className="absolute inset-0 bg-gradient-to-br from-chart-1/5 via-transparent to-chart-2/5 dark:from-chart-1/10 dark:to-chart-2/10" />

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto text-center"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            Comienza a transformar tus
            <span className="bg-gradient-to-r from-chart-1 to-chart-2 text-transparent bg-clip-text block mt-1">
              finanzas hoy mismo
            </span>
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            Únete a miles de freelancers, empresas y MYPEs peruanas que ya
            optimizaron su gestión financiera con finanza.lat
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button
              size="lg"
              onClick={goRegister}
              className="bg-gradient-to-r from-chart-1 to-chart-2 hover:from-chart-1/90 hover:to-chart-2/90 text-white"
            >
              Comenzar prueba gratuita
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
            {/* <Button size="lg" variant="outline">
              Solicitar demostración
            </Button> */}
          </div>

          <p className="text-sm text-muted-foreground mt-6">
            No se requiere tarjeta de crédito. Prueba gratuita.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
